(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory({});
  } else {
    root.FAAlcoholVerification = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (root) {
  'use strict';

  var document = root.document;
  var cookieName = 'faAlcoholAgeVerified';
  var storageName = 'faAlcoholAgeVerified';
  var dialog;
  var form;
  var dateInput;
  var error;
  var pendingAction = null;
  var returnFocus = null;

  function readCookie(name) {
    if (!document) return false;
    var prefix = name + '=';
    return document.cookie.split(';').some(function (part) {
      return part.trim().indexOf(prefix) === 0 && part.trim().slice(prefix.length) === 'true';
    });
  }

  function readSessionStorage() {
    try {
      return root.sessionStorage.getItem(storageName) === 'true';
    } catch (storageError) {
      return false;
    }
  }

  function isVerified() {
    return readCookie(cookieName) || readSessionStorage();
  }

  function rememberVerification() {
    if (!document) return;
    document.cookie = cookieName + '=true; Path=/; SameSite=Lax; Secure';
    try {
      root.sessionStorage.setItem(storageName, 'true');
    } catch (storageError) {
      // The session cookie remains the primary, browser-session-only record.
    }
  }

  function parseDateParts(year, month, day) {
    if ([year, month, day].some(Number.isNaN)) return null;

    var parsed = new Date(Date.UTC(year, month - 1, day));
    if (parsed.getUTCFullYear() !== year || parsed.getUTCMonth() !== month - 1 || parsed.getUTCDate() !== day) {
      return null;
    }
    return parsed;
  }

  function parseDate(value) {
    var normalized = String(value || '').trim();
    var isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalized);

    if (isoMatch) {
      return parseDateParts(Number(isoMatch[1]), Number(isoMatch[2]), Number(isoMatch[3]));
    }

    var fallbackMatch = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(normalized);
    if (!fallbackMatch) return null;

    return parseDateParts(Number(fallbackMatch[3]), Number(fallbackMatch[2]), Number(fallbackMatch[1]));
  }

  function formatDate(date) {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0')
    ].join('-');
  }

  function ageCutoff(todayValue) {
    var today = parseDate(todayValue || (dialog && dialog.dataset.shopDate));
    if (!today) {
      var now = new Date();
      today = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    }
    today.setUTCFullYear(today.getUTCFullYear() - 18);
    return today;
  }

  function isOldEnough(dateOfBirthValue, todayValue) {
    var dateOfBirth = parseDate(dateOfBirthValue);
    var earliestDate = parseDate('1900-01-01');
    return Boolean(dateOfBirth && dateOfBirth >= earliestDate && dateOfBirth <= ageCutoff(todayValue));
  }

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
    dateInput.setAttribute('aria-invalid', 'true');
    dateInput.focus();
  }

  function clearError() {
    error.textContent = '';
    error.hidden = true;
    dateInput.removeAttribute('aria-invalid');
  }

  function closeDialog() {
    pendingAction = null;
    form.reset();
    clearError();
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    returnFocus = null;
  }

  function openDialog(action, trigger) {
    pendingAction = action;
    returnFocus = trigger || document.activeElement;
    clearError();
    dateInput.max = formatDate(ageCutoff());
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    dateInput.focus();
  }

  function ensureVerification(action, trigger) {
    if (isVerified()) return true;
    if (!dialog) init();
    if (!dialog) return false;
    openDialog(action, trigger);
    return false;
  }

  function confirmAge(event) {
    event.preventDefault();
    clearError();
    var dateOfBirth = parseDate(dateInput.value);
    if (!dateOfBirth) {
      showError('Enter a valid date of birth.');
      return;
    }
    if (!isOldEnough(dateInput.value, dialog.dataset.shopDate)) {
      showError('You must be aged 18 or over to add alcohol to your basket.');
      return;
    }

    rememberVerification();
    var action = pendingAction;
    pendingAction = null;
    form.reset();
    clearError();
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    returnFocus = null;
    if (typeof action === 'function') action();
  }

  function init() {
    if (!document || dialog) return;
    dialog = document.querySelector('[data-alcohol-verification]');
    if (!dialog) return;
    form = dialog.querySelector('[data-alcohol-verification-form]');
    dateInput = dialog.querySelector('[data-alcohol-date-of-birth]');
    error = dialog.querySelector('[data-alcohol-verification-error]');

    if (dialog.dataset.cartHasAlcohol === 'true') rememberVerification();
    dateInput.max = formatDate(ageCutoff());

    form.addEventListener('submit', confirmAge);
    dialog.querySelector('[data-alcohol-verification-cancel]').addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog();
    });
    dateInput.addEventListener('input', clearError);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.js-ajax-submit');
      if (!button || button.disabled) return;
      var productForm = button.closest('[data-alcohol-restricted="true"]');
      if (!productForm || isVerified()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openDialog(function () {
        button.click();
      }, button);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target === form || isVerified()) return;
      var productForm = event.target.closest('[data-alcohol-restricted="true"]');
      if (!productForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var submitter = event.submitter || productForm.querySelector('[type="submit"]');
      openDialog(function () {
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        } else if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          productForm.submit();
        }
      }, submitter || productForm);
    }, true);
  }

  if (document && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else if (document) {
    init();
  }

  return {
    ensure: ensureVerification,
    isOldEnough: isOldEnough,
    isVerified: isVerified,
    parseDate: parseDate
  };
}));
